// extracted by mini-css-extract-plugin
module.exports = {"layoutMain":"Basic_layoutMain__m2zYD","layoutContent":"Basic_layoutContent__3-AYF"};